import {
  performValidation,
} from "./apple-pay-rest-client";
import {
  merchantIdentifier,
  merchantDisplay,
  APPLE_PAY_VERSION_NUMBER, merchantCapabilities, supportedNetworks,
} from "./applePayUtil";
import {PaymentStatus} from "./payment-status";
import {cloneMe} from "@/vendor/util";
import {COUNTRY_CODE, CURRENCY_CODE} from "../../vendor/qconstants";

export const appleCanMakePayments = () => {
  console.log("appleCanMakePayments");
  return new Promise((resolve, reject) => {
    try {
      const enabled =
        window.ApplePaySession && window.ApplePaySession.canMakePayments();
      resolve(enabled);
    } catch (err) {
      reject(err);
    }
  });
};

// export const appleCanMakePaymentsWithActiveCard = () => {
//   return appleCanMakePayments().then(() => {
//     console.log("appleCanMakePaymentsWithActiveCard");
//     return window.ApplePaySession.canMakePaymentsWithActiveCard(
//       merchantIdentifier
//     );
//   });
// };

const getPaymentRequest = (currencyCode, label, amount) => {
  return {
    currencyCode: currencyCode,
    countryCode: COUNTRY_CODE,
    //requiredShippingContactFields: ['name', 'email', 'phone'],
    // lineItems: items,
    total: {
      label: label,
      amount: amount,
    },
    supportedNetworks: supportedNetworks,
    merchantCapabilities: merchantCapabilities,
  };
};

const getOnValidateMerchant = (session) => {
  return (event) => {
    console.log('performValidation...');
    performValidation(
      event.validationURL,
      merchantIdentifier,
      merchantDisplay,
      window.location.hostname
    )
      .then((response) => {
        console.log('ApplePayJS completed performValidation response='+JSON.stringify(response));
        session.completeMerchantValidation(response);
        console.log('ApplePayJS completeMerchantValidation');
      })
      .catch((err) => {
        console.log("merchant Validate error ", JSON.stringify(err));
        session.abort();
      });
  };
};

const getOnPaymentAuthorized = (
  resolve, session,
) => {
  return (event) => {
    let payment = cloneMe(event.payment);
    console.log('getOnPaymentAuthorized... event.payment = ' + JSON.stringify(payment));
    // resolve(event);
    session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
    resolve(payment);
    // // amount must be provided in cents
    // performApplePayDebit(
    //   amount * 100,
    //   currencyCode,
    //   event.payment.token.paymentData
    // )
    //   .then((response) => {
    //     if (response.code === 100) {
    //       session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
    //       resolve(PaymentStatus.SUCCESS);
    //     } else {
    //       console.log("Payment error in response ", JSON.stringify(response));
    //       session.completePayment(window.ApplePaySession.STATUS_FAILURE);
    //       resolve(PaymentStatus.FAILURE);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("Payment error ", JSON.stringify(err));
    //     session.completePayment(window.ApplePaySession.STATUS_FAILURE);
    //     reject(err);
    //   });
  };
};

const getOnCancel = (resolve, reject, session) => {
  return (event) => {
    console.log("Session cancelled!!!");
    // resolve(PaymentStatus.CANCEL);
    reject(PaymentStatus.CANCEL)
  };
};

export const performApplePayPayment = (label, amount) => {
  return new Promise((resolve, reject) => {
    const session = new window.ApplePaySession(
      APPLE_PAY_VERSION_NUMBER,
      getPaymentRequest(CURRENCY_CODE, label, amount)
    );

    session.onvalidatemerchant = getOnValidateMerchant(
      session
    );
    session.onpaymentauthorized = getOnPaymentAuthorized(
      resolve, session
    );
    session.oncancel = getOnCancel(resolve, reject, session);

    session.begin();
  });
};
